import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LoginService } from '../../../services/login.service';

interface NavLink {
  label: string;
  fragment: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private login = inject(LoginService);

  readonly menuOpen = signal(false);
  readonly user = this.login.user; // potrzebny dla "Zaloguj się" (undefined = ukryj)

  links: NavLink[] = [
    { label: 'Gry', fragment: 'formats' },
    { label: 'Quiz', fragment: 'quiz' },
    { label: 'Jak to działa', fragment: 'steps' },
    { label: 'Panel DJ', fragment: 'dj' },
    { label: 'Opinie', fragment: 'social' },
    { label: 'FAQ', fragment: 'faq' },
    { label: 'Kontakt', fragment: 'kontakt' },
  ];

  toggleMenu() {
    this.menuOpen.update((v) => !v);
  }

  closeMenu() {
    this.menuOpen.set(false);
  }

  openLogin() {
    this.closeMenu();
    this.login.open();
  }

}
